import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ButtonType } from '@ascschool/interface/setting';
import { Province } from '@ascschool/model/category/province.model';
import { CommonFilter } from '@ascschool/model/commonfilter/commonfilter';
import { AuthService } from '@ascschool/core/auth/auth.service';
import { ConfirmComponent } from '@ascschool/project/popups/confirm/confirm.component';
import { SizePageService } from '@ascschool/project/size-page/size-page.service';
import { ProvinceService } from '@ascschool/services/category/province.service';
import { WardService } from '@ascschool/services/category/ward.service';
import { UtilsService } from '@ascschool/services/utils.service';
import { ShortcutInput } from 'ng-keyboard-shortcuts';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { NzUploadChangeParam } from 'ng-zorro-antd/upload';
import { Observable,Subject } from 'rxjs';
import { map, takeUntil} from 'rxjs/operators';
import { PopupImportTtnsComponent } from './popup-import-ttns/popup-import-ttns.component';
import { PopupThemTtnsComponent } from './popup-them-ttns/popup-them-ttns.component';
import { PopupXemTtnsComponent } from './popup-xem-ttns/popup-xem-ttns.component';
import { PopupTtnsComponent } from './popup-ttns/popup-ttns.component';
import { StaffService } from '@ascschool/services/user/staff.service';
import { Staff } from '@ascschool/model/user/staff.model';
import { SchoolService } from '@ascschool/services/organization/school.service';
import { BoardService } from '@ascschool/services/category/board.service';
import { TypeOfPersonnelService } from '@ascschool/services/category/type-of-personnel.service';
import { PositionService } from '@ascschool/services/category/position.service';
import { TbColumm } from '@ascschool/interface/table/column';
import { TbOption } from '@ascschool/interface/table/option';
import { DatePipe } from '@angular/common';
import { GenderPipe } from '@ascschool/pipe/gender.pipe';
import { Field, TypeField } from '@ascschool/interface/form/field';
import { DistrictService } from '@ascschool/services/category/district.service';
import { TypeOfPersonelPipe } from '@ascschool/pipe/typeOfPersonelPipe.pipe';
@Component({
    selector: 'app-thong-tin-nhan-su',
    templateUrl: './thong-tin-nhan-su.component.html',
    styleUrls: ['./thong-tin-nhan-su.component.scss']
})
export class ThongTinNhanSuComponent implements OnInit,OnDestroy, AfterViewInit {
    $unSubcribe = new Subject();
    isResizdePopup: boolean;
    dialogRef: NzModalRef;
    titlePopup: string;
    @ViewChild('tplTitle', { static: false }) titlePopupElement;
    get breadcrumbs(): string[] {
        return ['Quản lý nhân sự'];
    }
    // tslint:disable-next-line: adjacent-overload-signatures
    @ViewChild('pageHeaderTable', { static: false }) set content2(content2: ElementRef) {
        if (content2) {
            // initially setter gets called with undefined
            this.elementPageHeaderTable = content2;
        }
    }
    isClearBtn: boolean = false;

    constructor(
        private msg: NzMessageService, private cdRef: ChangeDetectorRef, public _authService: AuthService,
        public sizePageService: SizePageService, private modalService: NzModalService, private provinceService: ProvinceService,
        public utilService: UtilsService, private service: WardService, private staffService: StaffService,
        private schoolService: SchoolService, private boardService: BoardService,
        private typeofpersonnelService: TypeOfPersonnelService, private positionService: PositionService,
        private districtService: DistrictService,
    ) {
        this.currentUser = JSON.parse(localStorage.getItem('userSetting'));
    }
    formFeildItems: Field[];
    dataSearch: any;
    // thông tin cột table
    columns: TbColumm[] = [
        { columnName: 'Mã nhân sự', width: '115px', align: 'left', key: 'staffCode' },
        {
            columnName: 'Họ tên', width: '200px', align: 'left', key: 'fullName',
            sortFn: (a, b) => a.fullName.localeCompare(b.fullName),
        },
        {
            columnName: 'Năm sinh', width: '100px', align: 'left',
            key: 'yearOfBirth', isPipe: false, pipe: DatePipe, agrPipe: ['dd/MM/yyyy']
        },
        { columnName: 'Giới tính', width: '50px', align: 'left', key: 'gender', isPipe: true, pipe: GenderPipe, agrPipe: [] },
        { columnName: 'Dân tộc', width: '80px', align: 'left', key: 'folkName' },
        { columnName: 'Điện thoại', width: '100px', align: 'left', key: 'phoneNumber' },
        {
            columnName: 'Loại nhân sự', width: '150px', align: 'left', key: 'typeOfPersonnelName'
        },
        // { columnName: 'Vị trí công tác', width: '250px', align: 'left', key : 'positionName'}
    ];
    // tùy chọn table
    options: TbOption = {
        nzPageSizeOptions: [50, 100, 200], nzPageSize: 50, total: 0, columns: this.columns, numbernzLeft: 3,
        numbernzRight: 1, nzPageIndex: 1, isIndexCol: true, isBtnCol: true, isInfoBtn: true, isEditBtn: true,
        isScrollTable: true, isCheckBoxCol: true
    };
    listCheckId = [];
    positionName1: string;
    currentUser: any;
    buttonTypeEnum = ButtonType;
    btnType: ButtonType;
    shortcuts: ShortcutInput[] = [];
    commonFilter = new CommonFilter();
    searchTerm = '';
    checkedAll = false;
    pageIndex = 1;
    pageSize = this.options.nzPageSizeOptions[0];
    province = new Province();
    listPersonSelected: number[] = [];
    divisibleForFour: boolean;
    provinceList: any;
    numberControl: number;
    districtList: any;
    subordinateTypeId: number;
    private elementPageHeaderTable: ElementRef;
    getProvinceACFn: (value: any) => Observable<any>;
    getSchoolACFn: (value: any) => Observable<any>;
    getBoardACFn: (value: any) => Observable<any>;
    getTypeofPersonnelACFn: (value: any) => Observable<any>;
    getPositionACFn: (value: any) => Observable<any>;
    @ViewChild('pageOptionBtnGroup', { static: false }) elementpageOptionBtnGroup: ElementRef;
    @ViewChild('pageSearch', { static: false }) elementPageSearch: ElementRef;
    show = false;
    maxHeight: number;
    height: number;
    heightPopup: number;
    heightPagnagation = 50;
    isCollapse = true;
    dataTable: any = [];
    getDistrictACFn: (value: any) => Observable<any>;
    DistrictSubscription: any;
    DistrictControl = new FormControl();
    valueProvince: any;
    valueSchool: any;
    valueDistrict: any;
    ProvinceId: number;
    isDisabled: boolean = false;
    isDisabled1: boolean = false;
    isDisabled2: boolean = false;
    isnotClear: any;
    sortNameFn = (a: Province, b: Province) => a.provinceName.localeCompare(b.provinceName);
    ngOnInit() {
        if (this.currentUser.accountType === 3) {
            this.isDisabled = true;
            this.commonFilter.IsStaffCreateByUser = false;
        } else if (this.currentUser.accountType === 1) {
            this.commonFilter.IsStaffCreateByUser = true;
            this.isDisabled1 = true;
        } else if (this.currentUser.accountType === 2) {
            this.commonFilter.IsStaffCreateByUser = true;
            this.isDisabled2 = true;
        } else {
           delete this.commonFilter.IsStaffCreateByUser;
        }
        // if(this.currentUser.accountType === 6 || this.currentUser.accountType === 5){
        //   this.isnotClear =  true;
        // }else if(this.currentUser.accountType === 6 || this.currentUser.accountType === 5 || this.currentUser.accountType === 1){
        //   this.isnotClear =  true;
        // }
        // else if(this.currentUser.accountType !== 3){
        //   this.isnotClear =  this.formFeildItems[2].value.setValue(null)
        // }
        if (this.currentUser.accountType == 3) {
            this.provinceService.getSelectPagingProvinceById(this.currentUser.provinceId).subscribe(res => {
                this.ProvinceId = this.currentUser.provinceId;
                this.formFeildItems[0].value = { id: res.id, text: res.provinceName };
                this.getSchoolACFn = (value: any) => this.schoolService.getSelectPagingForStaff({
                    searchTerm: value, ProvinceId: this.currentUser.provinceId, SubordinateTypeId: 0, DistrictId: 0, PageIndex: 1, PageSize: 100
                }).pipe(map(resp => resp.results.length > 0
                    ? resp.results.map(x => ({ id: x.id, text: x.educationAndTrainingName })) : [{ id: null, text: 'Không có dữ liệu' }]));
            });
            this.districtService.getSelectPagingDistrictById(this.currentUser.districtId).subscribe(response => {
                this.formFeildItems[1].value = { ProvinceId: response.provinceId, id: response.id, text: response.districtName }
                this.loadDistrict(this.currentUser.provinceId);
            });
            this.schoolService.GetSelectPagingById(this.currentUser.eadId).subscribe(response => {
                this.formFeildItems[2].value = { ProvinceId: this.currentUser.provinceId, id: response.id, text: response.educationAndTrainingName }
                this.loadSchool(this.currentUser.provinceId, this.currentUser.districtId);
            });

        }
        if (this.currentUser.accountType === 1) {
            this.subordinateTypeId = this.currentUser.eadId;
            this.provinceService.getSelectPagingProvinceById(this.currentUser.provinceId).subscribe(res => {
                this.ProvinceId = this.currentUser.provinceId;
                this.formFeildItems[0].value = { id: res.id, text: res.provinceName };
                this.loadDistrict(res.id)
            });
        } else {
            this.subordinateTypeId = 0;
        }

        if (this.currentUser.accountType === 2) {
            this.subordinateTypeId = this.currentUser.eadId;
            this.provinceService.getSelectPagingProvinceById(this.currentUser.provinceId).subscribe(res => {
                this.ProvinceId = this.currentUser.provinceId;
                this.formFeildItems[0].value = { id: res.id, text: res.provinceName };

                this.districtService.getSelectPagingDistrictById(this.currentUser.districtId).subscribe(response => {
                    this.formFeildItems[1].value = { id: response.id, text: response.districtName }
                    this.loadDistrict(this.currentUser.provinceId);

                    // this.schoolService.GetSelectPagingById(this.currentUser.eadId).subscribe(response => {
                    //   this.formFeildItems[2].value = { ProvinceId: this.currentUser.provinceId, id: response.id, text: response.educationAndTrainingName }
                    //   this.loadSchool(this.currentUser.provinceId, this.currentUser.districtId);
                    // });
                });
                this.loadSchool(this.currentUser.provinceId, this.currentUser.districtId);


            });
        }
        this.commonFilter.subordinateTypeId = this.subordinateTypeId;
        this.commonFilter.PageIndex = 1;
        this.commonFilter.PageSize = this.options.nzPageSizeOptions[0];
        this.loadProvince();
        this.loadPosition();
        this.loadBoard();
        this.loadTypeofPersonnel();
        this.reload();
        this.maxHeight = window.innerHeight;

        this.formFeildItems = [
            new Field('Tỉnh thành', TypeField.SELECT_AUTOCOMPLETE, 'ProvinceId', 'Chọn tỉnh thành', false, this.isDisabled || this.isDisabled1 || this.isDisabled2, 6, this.valueProvince, null, null, null, this.getProvinceACFn, this.changeProvince.bind(this)),
            new Field('Quận huyện', TypeField.SELECT_AUTOCOMPLETE, 'DistrictId', 'Chọn quận huyện', false, this.isDisabled || this.isDisabled2, 6, this.valueDistrict, null, null, null, this.getDistrictACFn, this.changeDistrict.bind(this)),
            new Field('Cơ sở', TypeField.SELECT_AUTOCOMPLETE, 'SchoolId', 'Chọn cơ sở', false, this.isDisabled, 6, this.valueSchool, null, null, null, this.getSchoolACFn),
            new Field('Mã nhân sự', TypeField.INPUT, 'StaffCode', 'Nhập mã nhân sự', false, null, 6),
            new Field('Họ tên', TypeField.INPUT, 'FullName', 'Nhập họ tên', false, null, 6),
            new Field('Giới tính', TypeField.RADIO, 'Gender', '', false, null, 6, '', null, [{ lable: "Nam", key: 1 }, { lable: "Nữ", key: 0 }, { lable: "Tất cả", key: '' }]),
            // new Field('Vị trí công tác', TypeField.SELECT_AUTOCOMPLETE, 'PositionId', 'Chọn vị trí công tác', false, null, 6, null, null, null, null, this.getPositionACFn),
            new Field('Loại nhân sự', TypeField.SELECT_AUTOCOMPLETE, 'TypeofPersonnelId', 'Chọn loại nhân sự', false, null, 6, null, null, null, null, this.getTypeofPersonnelACFn),
        ];
    }
    reload() {
        this.checkedAll = false;
        this.staffService.get(this.commonFilter).pipe(takeUntil(this.$unSubcribe)).subscribe(response => {
            response.results.forEach(element => {
                this.positionName1 = element.positionName != null ? element.positionName : element.positionGVName;

            });

            this.options.total = response.rowCount;
            this.dataTable = response.results;
        });
    }
    search(event) {
        if (this.currentUser.accountType === 3) {
            this.commonFilter.IsStaffCreateByUser = false;
        } else if (this.currentUser.accountType === 1) {
            this.commonFilter.IsStaffCreateByUser = true;
        } else if (this.currentUser.accountType === 2) {
            this.commonFilter.IsStaffCreateByUser = true;
        } else {
          delete this.commonFilter.IsStaffCreateByUser;
        }
        // this.commonFilter = event;
        this.commonFilter = new CommonFilter;
        this.commonFilter.PageIndex = 1;
        this.commonFilter.PageSize = this.pageSize;
        this.commonFilter.subordinateTypeId = this.subordinateTypeId;
        Object.keys(event).forEach((key) => {
            this.commonFilter[key] = event[key];
        })
        this.reload();
    }
    pageIndexEvent(pageE: any) {
        this.commonFilter.PageIndex = pageE;
        this.options.nzPageIndex = pageE;
        this.pageIndex = pageE;
        this.reload();
    }
    pageSizeEvent(pageE: any) {
        this.commonFilter.PageSize = pageE;
        this.options.nzPageSize = pageE;
        this.pageSize = pageE;
        this.reload();
    }
    ngAfterViewInit() {
        this.checkCaculateSizeTable();
        // keyboard
        this.shortcuts.push({
            key: ['alt + n'], label: 'Help', description: 'Cmd + b', command: (e) => this.addpersonnel(), preventDefault: true
        });
        this.cdRef.detectChanges();
    }
    checkCaculateSizeTable() {
        setTimeout(() => {
            this.options.height = this.heightfnc();
            this.options.width = this.widthfnc();
        }, 1);
    }
    heightfnc() {
        return this.sizePageService.caculateHeight(
            this.elementpageOptionBtnGroup,
            this.elementPageSearch,
            this.elementPageHeaderTable,
            this.heightPagnagation
        );
    }
    widthfnc() {
        return this.sizePageService.caculateWidth(this.elementPageSearch);
    }
    caculateHeightPopup(maxHeight: number): number {
        let heightModal: number;
        if (maxHeight > 950) {
            return (heightModal = 700 + (maxHeight - 860));
        } else {
            return (heightModal = 700 - (860 - maxHeight));
        }
    }
    onResize() {
        this.checkCaculateSizeTable();
    }
    handleChange(info: NzUploadChangeParam): void {
        if (info.file.status !== 'uploading') {
        }
        if (info.file.status === 'done') {
            this.msg.success(`${info.file.name} file uploaded successfully`);
        } else if (info.file.status === 'error') {
            this.msg.error(`${info.file.name} file upload failed.`);
        }
    }
    toggleCollapse(): void {
        this.maxHeight = window.innerHeight;
        this.checkCaculateSizeTable();
    }
    resetForm(): void { }
    edit(item: any) {
        this.isResizdePopup = false;
        this.titlePopup = 'Chỉnh sửa - thông tin nhân sự';
        this.dialogRef = this.modalService.create({
            nzTitle: this.titlePopupElement,
            nzContent: PopupTtnsComponent,
            nzStyle: { top: '30px' },
            nzMaskClosable: false,
            nzBodyStyle: {
                overflow: 'auto',
                maxheight: this.caculateHeightPopup(window.innerHeight) + 'px',
                height: this.caculateHeightPopup(window.innerHeight) + 'px',
            },
            nzComponentParams: { value: item },
            nzWidth: 1500
        });
        // const instance = dialogRef.getContentComponent();
        this.dialogRef.afterClose.subscribe((result) => {
            if (result) {
                this.reload();
            }
        });
        // item la 1 danh muc du thi
    }
    addpersonnel() {
        this.isResizdePopup = false;
        this.titlePopup = 'Thêm - thông tin nhân sự';
        this.dialogRef = this.modalService.create({
            nzTitle: this.titlePopupElement,
            nzContent: PopupThemTtnsComponent,
            nzStyle: { top: '20px' },
            nzMaskClosable: false,
            nzComponentParams: { EducationAndTrainingOrSchoolId: this.commonFilter.SchoolId },
            nzBodyStyle: {
                overflow: 'auto',
                maxheight: this.caculateHeightPopup(window.innerHeight) + 'px',
                height: this.caculateHeightPopup(window.innerHeight) + 'px',
            },
            nzWidth: 1500
        });
        // const instance = dialogRef.getContentComponent();
        this.dialogRef.afterClose.subscribe((result) => {
            if (result) {
                this.reload();
            }
        });
    }
    delete(item: Staff) {
        const dialogRef = this.modalService.create({
            nzTitle: 'Xóa - thông tin nhân sự',
            nzContent: ConfirmComponent,
            nzComponentParams: { description: item.fullName },
            nzStyle: { top: '20px' },
            nzMaskClosable: false
        });
        dialogRef.afterClose.subscribe((result) => {
            if (result) {
                this.service.deleteWard(item.id).subscribe((res: any) => {
                    this.notification(res);
                    this.reload();
                });
            }
        });
    }
    notification(response) {
        if (response.statusCode === 0) {
            this.msg.success('Cập nhật thông tin ' + response.message);
        } else {
            this.msg.error('Lỗi: ' + response.message);
        }
    }
    loadProvince() {
        this.getProvinceACFn =
            (value: any) => this.provinceService.GetSelectPagingProvinceBySubordinateType({
                searchTerm: value, PageIndex: 1, PageSize: 100
            }).pipe(map(resp => resp.length > 0
                ? resp.map(x => ({ id: x.id, text: x.provinceName })) : [{ id: null, text: 'Không có dữ liệu' }]));
    }
    changeProvince(event: any) {
        this.ProvinceId = event;
        if (event != null) {
            this.ProvinceId = event.id;
            this.loadSchool(event.id, 0);
            this.loadDistrict(event.id);
        } else {
            this.loadSchool(null);
            this.loadDistrict(null);
        }
    }
    loadSchool(idProvince: any, idDistrict?: any) {
        // tslint:disable-next-line: max-line-length
        this.getSchoolACFn = (value: any) => this.schoolService.getSelectPagingForStaff({
            searchTerm: value, ProvinceId: idProvince, SubordinateTypeId: this.commonFilter.subordinateTypeId, DistrictId: idDistrict, PageIndex: 1, PageSize: 100
        }).pipe(map(resp => resp.results.length > 0
            ? resp.results.map(x => ({ id: x.id, text: x.educationAndTrainingName })) : [{ id: null, text: 'Không có dữ liệu' }]));
        this.formFeildItems[2].autoComplete = this.getSchoolACFn;
    }
    loadDistrict(idDistrict: any) {
        this.getDistrictACFn = (value: any) => this.districtService.getDistrictSelectPaging({
            searchTerm: value, ProvinceId: idDistrict, PageIndex: 1, PageSize: 100
        }).pipe(map(resp => resp.results.length > 0
            ? resp.results.map(x => ({ id: x.id, text: x.districtName })) : [{ id: null, text: 'Không có dữ liệu' }]));
        this.formFeildItems[1].autoComplete = this.getDistrictACFn;
    }
    changeDistrict(event: any) {
        // this.Dist = event;
        if (event != null) {
            this.loadSchool(this.ProvinceId, event.id);
        } else {
            this.loadSchool(null);
        }
    }
    loadBoard() {
        this.getBoardACFn = (value: any) => this.boardService.getBoardSelectPaging({
            searchTerm: value, PageIndex: 1, PageSize: 100
        }).pipe(map(resp => resp.results.length > 0
            ? resp.results.map(x => ({ id: x.id, text: x.boardName })) : [{ id: null, text: 'Không có dữ liệu' }]));
    }
    loadTypeofPersonnel() {
        // tslint:disable-next-line: max-line-length
        this.getTypeofPersonnelACFn = (value: any) => this.typeofpersonnelService.getTypeOfPersonnelSelectPaging({
            searchTerm: value, PageIndex: 1, PageSize: 100
        }).pipe(map(resp => resp.results.length > 0
            ? resp.results.map(x => ({ id: x.id, text: x.typeOfPersonnelName })) : [{ id: null, text: 'Không có dữ liệu' }]));
    }
    loadPosition() {
        this.getPositionACFn = (value: any) => this.positionService.getSelectPaging({
            searchTerm: value, PageIndex: 1, PageSize: 100
        }).pipe(map(resp => resp.results.length > 0
            ? resp.results.map(x => ({ id: x.id, text: x.positionName })) : [{ id: null, text: 'Không có dữ liệu' }]));
    }

    importNhanSu() {
        const dialogRef = this.modalService.create({
            nzTitle: 'Import - thông tin nhân sự',
            nzContent: PopupImportTtnsComponent,
            nzComponentParams: { schoolId: this.commonFilter.SchoolId, provinceId: this.ProvinceId },
            nzStyle: { top: '20px' },
            nzBodyStyle: {
                overflow: 'auto',
                maxheight: this.caculateHeightPopup(window.innerHeight) + 'px',
                height: this.caculateHeightPopup(window.innerHeight) + 'px'
            },
            nzMaskClosable: false
        });
        dialogRef.afterClose.subscribe(() => {
            this.reload();
        });

    }
    deleteMany() {
        this.listPersonSelected = [];
        this.listCheckId.forEach(element => {
            this.listPersonSelected.push(element);
        });
        if (this.listPersonSelected.length > 0) {
            const dialogRef = this.modalService.create({
                nzTitle: 'Xóa - thông tin nhân sự',
                nzContent: ConfirmComponent,
                nzStyle: { top: '20px' },
                nzMaskClosable: false,
                nzComponentParams: { description: 'nhân sự đã chọn' },
            });
            dialogRef.afterClose.subscribe((result) => {
                if (result) {
                    this.staffService.deleteMulti(this.listPersonSelected).subscribe((res: any) => {
                        this.notification(res);
                        this.reload();
                    });
                }
            });
        } else {
            this.msg.warning('Bạn chưa chọn dữ liệu để xóa');
        }
    }
    exportExcel() {
        // document.getElementById('btnvF').click();
        if (this.ProvinceId) {
            this.staffService.exportExcel(this.commonFilter).subscribe((data) => {
                var downloadURL = window.URL.createObjectURL(data);
                var link = document.createElement('a');
                link.href = downloadURL;
                link.download = 'DanhSachNhanSu.xlsx';
                link.click();
            });
        } else {
            this.msg.warning('Vui lòng chọn Tỉnh thành');
        }
    }
    viewInfo(item: any) {
        this.isResizdePopup = false;
        this.titlePopup = 'Xem - thông tin nhân sự';
        this.dialogRef = this.modalService.create({
            nzTitle: this.titlePopupElement,
            nzContent: PopupXemTtnsComponent,
            nzStyle: { top: '20px' },
            nzComponentParams: { value: item },
            nzBodyStyle: {
                overflow: 'auto',
                maxheight: this.caculateHeightPopup(window.innerHeight) + 'px',
                height: this.caculateHeightPopup(window.innerHeight) + 'px'
            },
            nzMaskClosable: false,
            nzWidth: 1500
        });
    }
    hanlderCheckedId(event) {
        this.listCheckId = event;
    }
    changeValue(event) {
        if (event.SchoolId) {
            this.commonFilter.SchoolId = event.SchoolId.id
        }
    }
    handlerResizePopup() {
        this.isResizdePopup = !this.isResizdePopup;
        let width = 1500;
        let height = this.caculateHeightPopup(window.innerHeight) + 'px';
        let top = 30;
        if (this.isResizdePopup === true) {
            width = window.innerWidth;
            top = 15;
            height = this.caculateHeightPopup(window.innerHeight) + 50 + 'px';
        }
        this.dialogRef.updateConfig({
            nzWidth: width,
            nzStyle: { top: top + 'px' },
            nzBodyStyle: { overflow: 'auto', maxheight: height, height: height }
        });
    }
    ngOnDestroy(): void {
        this.$unSubcribe.next();
        this.$unSubcribe.complete();
    }
}
